<template>
    <div class="card">
        <form class="card-header bg-white" @submit.prevent="data.fetch()">
            <div class="d-flex justify-content-between align-items-center">
                <h3 class="text-5 font-weight-400"> Batch History </h3>
                <div class="input-group input-group-sm w-50">
                    <input v-model="data.filters.search" type="text"
                           class="form-control"
                           style="height: auto !important;"
                           placeholder="Search">
                    <div class="input-group-append">
                        <button @click.prevent="data.fetch()"
                                class="btn btn-primary"
                                :class="[data.loading ? 'btn-loading' : '' ]">
                            Refresh
                        </button>
                    </div>
                </div>
            </div>
        </form>
        <div class="card-body">

            <!-- Title
            =============================== -->
            <div class="transaction-title py-2 px-4">
                <div class="row">
                    <div class="col-2 col-sm-1 text-center"><span class="">Date</span></div>
                    <div class="col col-sm-7">Description</div>
                    <div class="col-auto col-sm-2 d-none d-sm-block text-center"></div>
                    <div class="col-3 col-sm-2 text-right"></div>
                </div>
            </div>
            <!-- Title End -->

            <!-- Transaction List
            =============================== -->
            <div class="transaction-list">
                <div class="transaction-item px-4 py-3" v-for="row in data.content.data">
                    <div class="row align-items-center flex-row">
                        <div class="col-2 col-sm-1 text-center"><span
                            class="d-block text-4 font-weight-300">{{ row.day }}</span> <span
                            class="d-block text-1 font-weight-300 text-uppercase">{{ row.month }}</span>
                        </div>
                        <div class="col col-sm-7"><span class="d-block text-4">{{ row.code }}</span> <span
                            class="text-muted">{{ row.corporate_name }} {{ row.phone }} {{ row.email }}</span></div>
                        <div class="col-auto col-sm-2 d-none d-sm-block text-center text-3"><span
                            class="text-primary" data-toggle="tooltip"
                            data-original-title="In Progress">
                                        {{ row.state }}
                                    </span>
                        </div>
                        <div class="col-3 col-sm-2 text-right text-4"><span
                            class="text-nowrap">{{ row.meta.total }}</span> <span
                            class="text-2 text-uppercase">({{
                                row.payment_type === 'App\\StripePayment' ? 'USD' : 'ZWG'
                            }})</span></div>
                    </div>
                </div>
            </div>
            <!-- Transaction List End -->

            <!-- View all Link =============================== -->
            <div v-if="data.content.total !== data.content.to && data.content.data.length > 0"
                 class="text-center mt-4">
                <a href="#" @click.prevent="data.append()" class="btn-link text-3">Load More<i
                    class="fas fa-chevron-right text-2 ml-2"></i>
                </a>
            </div>
            <!-- View all Link End -->
        </div>
    </div>
</template>

<script>
import Data from "../../core/data/Data";

export default {
    name: "profile",

    data() {
        return {
            data: new Data({
                url: '/admin/auth/batches',
                prefix: 'list'
            })
        };
    },
    mounted() {
        this.data.fetch()
    }

}
</script>

<style scoped>

</style>
